import React from 'react';
import './HeroArtwork.css';

function HeroArtwork() {
  return (
    <div className="hero-artwork" aria-hidden="true">
      <picture className="hero-panel-picture">
        <source
          media="(max-width: 767px)"
          srcSet="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2Uvd2VicA==/82c310c85d0c7f35e0456ed115e9f1eb.webp"
        />
        <img
          className="hero-panel-image"
          src="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2Uvd2VicA==/d21f115994416cc28a1bdb8951e31a2c.webp"
          alt=""
          decoding="async"
          fetchPriority="high"
        />
      </picture>
    </div>
  );
}

export default HeroArtwork;